module.exports = __webpack_public_path__ + "static/media/humidity_low.c60f4922.png";